import { environment } from '../../../environments/environment';
import { Utility } from '../utility';

export const emojiQiuQiu = {
    label: '球球',
    height: 90,
    width: 90,
    path:"/upload/facetime/qiuqiu/",
    range:[[20210601,20210616]]
    // items: [
    //     {
    //         'not': 20210601,
    //         'id': 20210601,
    //         'image': '/upload/facetime/qiuqiu/20210601.gif',
    //         'title': '按摩',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210601)',
            
    //         'GroupID': 202106
    //     },
    //     {
    //         'not': 20210602,
    //         'id': 20210602,
    //         'image': '/upload/facetime/qiuqiu/20210602.gif',
    //         'title': '拜拜',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210602)',
            
    //         'GroupID': 202106
    //     },
    //     {
    //         'not': 20210603,
    //         'id': 20210603,
    //         'image': '/upload/facetime/qiuqiu/20210603.gif',
    //         'title': '蹦蹦跳跳',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210603)',
            
    //         'GroupID': 202106
    //     },
    //     {
    //         'not': 20210604,
    //         'id': 20210604,
    //         'image': '/upload/facetime/qiuqiu/20210604.gif',
    //         'title': '冰淇淋',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210604)',
    //         'GroupID': 202106
    //     },
    //     {
    //         'not': 20210605,
    //         'id': 20210605,
    //         'image': '/upload/facetime/qiuqiu/20210605.gif',
    //         'title': '乖',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210605)',
            
    //         'GroupID': 202106
    //     },
    //     {
    //         'not': 20210606,
    //         'id': 20210606,
    //         'image': '/upload/facetime/qiuqiu/20210606.gif',
    //         'title': '开心',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210606)',
            
    //         'GroupID': 202106
    //     },
    //     {
    //         'not': 20210607,
    //         'id': 20210607,
    //         'image': '/upload/facetime/qiuqiu/20210607.gif',
    //         'title': '生无可恋',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210607)',
            
    //         'GroupID': 202106
    //     },
    //     {
    //         'not': 20210608,
    //         'id': 20210608,
    //         'image': '/upload/facetime/qiuqiu/20210608.gif',
    //         'title': '是谁？！',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210608)',
            
    //         'GroupID': 202106
    //     },
    //     {
    //         'not': 20210609,
    //         'id': 20210609,
    //         'image': '/upload/facetime/qiuqiu/20210609.gif',
    //         'title': '突然出现',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210609)',
            
    //         'GroupID': 202106
    //     },
    //     {
    //         'not': 20210610,
    //         'id': 202106010,
    //         'image': '/upload/facetime/qiuqiu/20210610.gif',
    //         'title': '玩弄',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210610)',
            
    //         'GroupID': 202106
    //     },
    //     {
    //         'not': 20210611,
    //         'id': 20210611,
    //         'image': '/upload/facetime/qiuqiu/20210611.gif',
    //         'title': '玩耍',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210611)',
            
    //         'GroupID': 202106
    //     },
    //     {
    //         'not': 20210612,
    //         'id': 20210612,
    //         'image': '/upload/facetime/qiuqiu/20210612.gif',
    //         'title': '问号',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210612)',
            
    //         'GroupID': 202106
    //     },
    //     {
    //         'not': 20210613,
    //         'id': 20210613,
    //         'image': '/upload/facetime/qiuqiu/20210613.gif',
    //         'title': '想要',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210613)',
            
    //         'GroupID': 202106
    //     },
    //     {
    //         'not': 20210614,
    //         'id': 20210614,
    //         'image': '/upload/facetime/qiuqiu/20210614.gif',
    //         'title': '心',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210614)',
            
    //         'GroupID': 202106
    //     },
    //     {
    //         'not': 20210615,
    //         'id': 20210615,
    //         'image': '/upload/facetime/qiuqiu/20210615.gif',
    //         'title': '醒星',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210615)',
            
    //         'GroupID': 202106
    //     },
    //     {
    //         'not': 20210616,
    //         'id': 20210616,
    //         'image': '/upload/facetime/qiuqiu/20210616.gif',
    //         'title': '早上好',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210616)',
            
    //         'GroupID': 202106
    //     },
    // ]
}
